// One visible-page clock; production customer readers check revisions before full refreshes.
const listeners=new Set(),revisions=new WeakMap(),legacyChecks=new WeakMap(),checking=new WeakSet();let timer=null,lastSignal=0;
const attempts=new WeakMap();
const retryDelays=[30000,60000,120000],cooldown=300000;
function temporaryRevisionFailure(error){return [408,429,500,502,503,504].includes(Number(error?.status))||require('./backgroundReadPolicy').transientReadFailure(error);}
const customerPaths=['/','/strategy-scoreboard','/legacy-dashboard','/todays-picks','/previous-picks','/results-performance','/share','/marketing-share'];
function customerReadPage(path){return customerPaths.includes(path);}
const day=()=>new Intl.DateTimeFormat('en-CA',{timeZone:'America/New_York',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date());
async function refreshGroup(auth,items){
 const transport=require('./savedReadTransport'),scope=transport.customerReaderScope(auth);
 if(!scope){const ready=items.filter(item=>!item.busy());for(const item of ready)item.run();return;}
 if(checking.has(auth)||items.some(i=>i.busy()))return;
 const date=day(),previous=attempts.get(auth),now=Date.now();
 if(previous?.date===date&&(previous.blocked||now<previous.next))return;
 if(previous&&previous.date!==date){
  // Never preserve yesterday's view across the Florida drawing-date boundary.
  attempts.set(auth,{date,failures:0,next:0});revisions.delete(auth);transport.invalidateSavedBoardCache(auth);
  for(const item of items)if(listeners.has(item))item.run();
  return;
 }
 checking.add(auth);
 try{
  const r=await transport.readBoard(auth,'/api/public?'+new URLSearchParams({action:'todays-picks-revision',state:'FL',game:'pick3',date}),{label:'customer-revision'});
  if(r?.status!=='ready'||!r.legacyRefresh&&!/^[a-f0-9]{64}$/.test(r.revision))throw Error('customer_revision_integrity');
  attempts.set(auth,{date,failures:0,next:0});
  const key=date+'|'+r.revision+'|'+r.pro,legacyDue=r.legacyRefresh&&(!legacyChecks.has(auth)||Date.now()-legacyChecks.get(auth)>=60000),changed=legacyDue||!r.legacyRefresh&&revisions.get(auth)!==key;
  if(legacyDue)legacyChecks.set(auth,Date.now());
  revisions.set(auth,key);
  if(changed)transport.invalidateSavedBoardCache(auth);
  for(const item of items)if(listeners.has(item)&&(changed||item.maxAge&&Date.now()-item.lastRun>=item.maxAge)){item.lastRun=Date.now();item.run();}
 }catch(error){
  if(temporaryRevisionFailure(error)){
   // A failed change signal is not evidence that previously verified data changed.
   // Three retries, then a five-minute cooldown before another bounded cycle.
   const failures=(previous?.date===date?previous.failures:0)+1;
   attempts.set(auth,{date,failures:failures>retryDelays.length?0:failures,next:Date.now()+(retryDelays[failures-1]??cooldown)});
   return;
  }
  // Authorization or malformed revision: clear once through the existing readers,
  // then wait for a new account/entitlement reader, drawing date or page reload.
  attempts.set(auth,{date,failures:0,next:Infinity,blocked:true});
  transport.invalidateSavedBoardCache(auth);revisions.delete(auth);
  for(const item of items)if(listeners.has(item))item.run();
 }finally{checking.delete(auth);}
}
function dispatch(reason){
 if(document.hidden)return;
 const now=Date.now();if(reason!=='interval'&&now-lastSignal<5000)return;lastSignal=now;
 const groups=new Map();for(const item of listeners){if(!item.auth){if(!item.busy())item.run();continue;}if(!groups.has(item.auth))groups.set(item.auth,[]);groups.get(item.auth).push(item);}
 for(const [auth,items] of groups)void refreshGroup(auth,items);
}
const visible=()=>dispatch('visible');
function subscribeCustomerRefresh(run,busy=()=>false,auth,{maxAge=0}={}){
 const item={run,busy,auth,maxAge,lastRun:Date.now()};listeners.add(item);
 if(!timer){timer=setInterval(()=>dispatch('interval'),30000);document.addEventListener('visibilitychange',visible);window.addEventListener('pageshow',visible);}
 return ()=>{listeners.delete(item);if(!listeners.size){clearInterval(timer);timer=null;lastSignal=0;document.removeEventListener('visibilitychange',visible);window.removeEventListener('pageshow',visible);}};
}
module.exports={subscribeCustomerRefresh,customerReadPage};
